import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventsService } from 'src/app/services/events.service';

@Component({
  standalone: false,
  selector: 'app-approve-reject-perticipant-modal',
  templateUrl: './approve-reject-perticipant-modal.component.html',
  styleUrls: ['./approve-reject-perticipant-modal.component.scss'],
})
export class ApproveRejectPerticipantModalComponent implements OnInit {

  @Input() selectedAdminId: string;
  @Input() status: string;
  @Input() participantId: string;

  approvalForm: FormGroup;

  finalSubmissionArray = [];
  isApprove: any;

  constructor(
    public modal: NgbActiveModal,
    private router: Router,
    private eventService: EventsService,
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
  ) {
    this.approvalForm = this.fb.group({
      comment: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.updateForm();
  }

  updateForm(): void {
    if (this.status === 'reject') {
      this.approvalForm.get('comment')?.setValidators(Validators.required);
      this.approvalForm.get('comment')?.updateValueAndValidity();
    } else {
      this.approvalForm.get('comment')?.clearValidators();
      this.approvalForm.get('comment')?.updateValueAndValidity();
    }
  }

  onSubmit(): void {
    this.finalSubmissionArray = [];
    if (this.status == 'approve') {
      this.isApprove = true;
    } else {
      this.isApprove = false;
    }
    if (this.approvalForm.valid) {
      this.finalSubmissionArray.push({
        "denialReason": this.approvalForm.value.comment,
        "taUserId": this.selectedAdminId,
        "isApprove": this.isApprove,
        "eventParticipantId": this.participantId
      });
      console.log(this.approvalForm.value);
      this.eventService
        .approveRejectEventPerticiaption(this.finalSubmissionArray[0])
        .subscribe((res) => {
          this.modalService.dismissAll();
          this.activeModal.dismiss();
          setTimeout(() => {
            window.location.reload();
          }, 5000);
        });
    } else {
      this.approvalForm.markAllAsTouched();
    }
  }

  changeStatusYes() {
    this.finalSubmissionArray = [];
    if (this.status == 'approve') {
      this.isApprove = true;
    } else {
      this.isApprove = false;
    }
    this.finalSubmissionArray.push({
      // "denialReason": this.approvalForm.value.comment,
      "taUserId": this.selectedAdminId,
      "isApprove": this.isApprove,
      "eventParticipantId": this.participantId
    });
    this.eventService
      .approveRejectEventPerticiaption(this.finalSubmissionArray[0])
      .subscribe((res) => {
        this.modalService.dismissAll();
        this.activeModal.dismiss();
        setTimeout(() => {
          window.location.reload();
        }, 5000);
      });
  }

  changeStatusNo() {
    this.modal.dismiss();
  }
}
